import {
  ENTRY_MODE,
  STORE_DineType,
  TABLE_NO,
} from "../../../../database/store-names";
import { SET_STORE_DINE_TYPE } from "../../../../database/store-data";
import { F_Fammily, Font } from "../../../../util/config-fonts";
import { ENCRYPT_STORAGE } from "../../../../config/config";
import { dto_common } from "../../../../classes/dto-common";
import { Colors } from "../../../../util/colors";
import { getQrTableNumber } from "../../../../functions/dine-type";
import React from "react";

export default class DisplayDineType extends React.Component {
  getDineType() {
    const { CSP } = dto_common;
    const DineType = Number(dto_common.DineType);
    const SelectedDineType = Number(ENCRYPT_STORAGE.getItem(STORE_DineType));
    const hasSelectedDineType = !Number.isNaN(SelectedDineType);
    const qrTableNo = getQrTableNumber(
      ENCRYPT_STORAGE.getItem(ENTRY_MODE),
      ENCRYPT_STORAGE.getItem(TABLE_NO),
    );

    if (qrTableNo !== "") {
      return {
        label: "DINE-IN",
        rightLabel: `Table ${qrTableNo}`,
        isDelivery: false,
      };
    }

    if (CSP === "MK") {
      return {
        label: DineType === 4 ? "DELIVERY ORDER" : "PICK UP ORDER",
        rightLabel: "",
        isDelivery: DineType === 4,
      };
    } else {
      if (hasSelectedDineType) {
        if (DineType !== SelectedDineType) {
          dto_common.DineType = SelectedDineType;
        }
        SET_STORE_DINE_TYPE(SelectedDineType);
        return {
          label: SelectedDineType === 4 ? "DELIVERY ORDER" : "PICK UP ORDER",
          rightLabel: "",
          isDelivery: SelectedDineType === 4,
        };
      }

      if (DineType === 4) {
        SET_STORE_DINE_TYPE(4);
        return {
          label: "DELIVERY ORDER",
          rightLabel: "",
          isDelivery: true,
        };
      }

      if (DineType === 3) {
        SET_STORE_DINE_TYPE(3);
        return {
          label: "PICK UP ORDER",
          rightLabel: "",
          isDelivery: false,
        };
      }

      dto_common.DineType = 4;
      SET_STORE_DINE_TYPE(4);
      return {
        label: "DELIVERY ORDER",
        rightLabel: "",
        isDelivery: true,
      };
    }
  }

  render() {
    const dineTypeDisplay = this.getDineType() || {};
    const dineTypeLabel = dineTypeDisplay.label || "";
    const rightLabel = dineTypeDisplay.rightLabel || "";
    const isDelivery = dineTypeDisplay.isDelivery === true;

    return (
      <div>
        <div
          style={{
            textAlign: "center",
            marginTop: 8,
            width: "100%",
          }}
        >
          <button
            style={{
              textAlign: "center",
              height: "48px",
              width: "100%",
              fontFamily: F_Fammily.Medium,
              fontSize: Font.MainHeading,
              borderRadius: "4px",
              background: Colors.LightGreyScale,
              color: "black",
              border: "none",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: rightLabel ? "space-between" : "center",
              paddingLeft: "14px",
              paddingRight: "14px",
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: rightLabel ? "flex-start" : "center",
                textAlign: "center",
              }}
            >
              <i
                className={
                  rightLabel
                    ? "bi bi-table"
                    : isDelivery
                      ? "fa fa-motorcycle"
                      : "bi bi-bag-fill"
                }
                aria-hidden="true"
                style={{ marginRight: 8, fontSize: 18 }}
              ></i>
              {dineTypeLabel}
            </span>
            {rightLabel ? <span>{rightLabel}</span> : null}
          </button>
        </div>
      </div>
    );
  }
}
